import React from "react";
import { useNavigate } from "react-router-dom";
import { BRAND_COLORS } from "../../config/brandColors.js";

function QuickAccessSection() {
  const navigate = useNavigate();

  const quickAccessItems = [
    {
      id: "healthops",
      title: "HealthOps Agent",
      description: "Chat with AI for health insights",
      icon: "🤖",
      color: BRAND_COLORS.primary.orange,
      path: "/aws/agents/healthops",
      gradient: "from-orange-500 to-orange-600"
    },
    {
      id: "aws-reports",
      title: "AWS Reports",
      description: "View AWS analytics",
      icon: "☷",
      color: BRAND_COLORS.support.green,
      path: "/aws/reports",
      gradient: "from-green-500 to-green-600"
    },
    {
      id: "create-account",
      title: "Create Account",
      description: "Create new AWS account",
      icon: "✚",
      color: BRAND_COLORS.support.blue,
      path: "/aws/create-account",
      gradient: "from-blue-500 to-blue-600"
    },
    
  ];

  const handleQuickAccess = (path) => {
    navigate(path);
  };

  return (
    <div 
      className="bg-white rounded-xl p-6"
      style={{ boxShadow: BRAND_COLORS.ui.shadowMedium }}
    >
      {/* Header */}
      <div 
        className="border-b pb-4 mb-6"
        style={{ borderColor: BRAND_COLORS.ui.borderLight }}
      >
        <div className="flex items-center justify-between">
          <div>
            <h2 
              className="text-xl font-semibold"
              style={{ color: BRAND_COLORS.primary.darkGray }}
            >
              Quick Access
            </h2>
            <p 
              className="text-sm mt-1"
              style={{ color: BRAND_COLORS.ui.textSecondary }}
            >
              Shortcuts to frequently used features
            </p>
          </div>
          
        </div>
      </div>

      {/* Quick Access Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        {quickAccessItems.map((item) => (
          <button
            key={item.id}
            onClick={() => handleQuickAccess(item.path)}
            className="group relative overflow-hidden rounded-xl p-4 text-left transition-all duration-300 hover:scale-105 hover:shadow-lg"
            style={{ 
              backgroundColor: `${item.color}08`,
              borderWidth: '1px',
              borderColor: `${item.color}20`
            }}
          >
            {/* Hover gradient effect */}
            <div 
              className={`absolute inset-0 bg-gradient-to-br ${item.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}
            ></div>

            {/* Content */}
            <div className="relative z-10">
              {/* Icon */}
              <div 
                className="w-12 h-12 rounded-lg flex items-center justify-center mb-3 transition-transform duration-300 group-hover:scale-110"
                style={{ backgroundColor: `${item.color}15` }}
              >
                <span className="text-2xl">{item.icon}</span>
              </div>

              {/* Title */}
              <h3 
                className="font-semibold text-sm mb-1 transition-colors duration-300"
                style={{ color: BRAND_COLORS.primary.darkGray }}
              >
                {item.title}
              </h3>

              {/* Description */}
              <p 
                className="text-xs leading-relaxed"
                style={{ color: BRAND_COLORS.ui.textSecondary }}
              >
                {item.description}
              </p>

              {/* Arrow indicator */}
              <div 
                className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{ color: item.color }}
              >
                <svg 
                  className="w-4 h-4" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M9 5l7 7-7 7" 
                  />
                </svg>
              </div>
            </div>
          </button>
        ))}
      </div>

      {/* Footer hint */}
      <div 
        className="mt-6 pt-4 border-t"
        style={{ borderColor: BRAND_COLORS.ui.borderLight }}
      >
        
      </div>
    </div>
  );
}

export default QuickAccessSection;
